import { Component, Injectable, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Observable } from 'rxjs';
import { AuthService } from 'src/app/services/auth/auth.service';
import { TelecomService } from 'src/app/services/telecom/telecom.service';
import { TimeService } from 'src/app/services/time/time.service';
import { environment } from 'src/environments/environment';
import { Guid } from 'guid-typescript';

@Injectable()
export class UniqueNameValidator {
  constructor( private snackbar: MatSnackBar) {}
  public onlyUniqueKeys(data: Array<any>, currentRow): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {


      if (!control) {
        return null;
      }
      
      let key = control.value

      let isDuplicated = false;
      for(let i=0;i<data.length; i++){
          if(key == data[i].name){
            isDuplicated = true; 
        }
      }
      
      //isDuplicated = data.includes((row) => { return key == row.name})
      if(isDuplicated){
        this.snackbar.open(`The name '${key}' is already in use.`, "Ok", {verticalPosition: 'bottom'})
        return { "onlyUnique": true};
      }
      return null;
    };
  }
  public onlyUniqueNumbers(data: Array<any>, formatPhoneNumber): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {


      if (!control) {
        return null;
      }
      
      let key = control.value

      let isDuplicated = false;
      for(let i=0;i<data.length; i++){
          if(formatPhoneNumber(key) == formatPhoneNumber(data[i].phoneNumber) && data[i].enabled){
            isDuplicated = true; 
        }
      }
      
      //isDuplicated = data.includes((row) => { return key == row.name})
      if(isDuplicated){
        this.snackbar.open(`The phone number '${key}' is already in use.`, "Ok", {verticalPosition: 'bottom'})
        return { "onlyUniqueNumber": true};
      }
      return null;
    };
  }
}

@Component({
  selector: 'app-dtc-campaigns',
  templateUrl: './dtc-campaigns.component.html',
  styleUrls: ['./dtc-campaigns.component.css']
})
export class DtcCampaignsComponent implements OnInit {

  constructor(private formBuilder:FormBuilder, private telecomService:TelecomService, private uniqueNameValidator:UniqueNameValidator, private timeService:TimeService, private auth:AuthService, private snackbar: MatSnackBar) { }
  
  data: Array<any> = [];
  filteredData = [];
  inactiveData = [];
  kpiData = [];
  creatingRow = false;
  rowSelected = -1;
  campaignTypes = ["Lead Gen Partner","Marketing Campaign", "Non-LeadCloud Partner"];
  queues : Array<any> = [];
  kpiQueues: Array<any> = [];
  languages = [["test", "Test"]];
  experienceTypes = ["Direct to Queue", "Abbreviated Menu", "Full Menu"];
  departments = ["Preferred", "UW", "Direct"];
  currentUser: string = this.auth.currentUser;
  editable: boolean = true;

  formatQueueFunction = (queue) => {
    if(typeof queue == "string"){
      return queue
    }
    return queue.queueName;
  }

  formatLanguageFunction = (language) => {
    if(this.languages.length>0){
      return this.languages.find((lang) => {return lang[1] == language})[0];
    }
    return language
  }

  formatPhoneNumberFunction = (phoneNumber) => {
    return this.displayFormatPhoneNumber(phoneNumber);
  }

  form = this.formBuilder.group({
    name: new FormControl('', []),
    campaignType: new FormControl('', [Validators.required]),
    experienceType: new FormControl('', [Validators.required]),
    phoneNumber: new FormControl('', [Validators.required, Validators.pattern(/^(\+?\d{1,2})?\s?\(?(\d{3})\)?[\s.-]?(\d{3})[\s.-]?(\d{4})$/), this.uniqueNameValidator.onlyUniqueNumbers(this.data, this.formatPhoneNumber)]),
    language: new FormControl('', [Validators.required]),
    queue: new FormControl('', [Validators.required]),
    whisper: new FormControl('', [Validators.required]),
    customPrompt: new FormControl('', [Validators.required]),
  }
  );
  kpiForm = this.formBuilder.group({
    kpiPhoneNumber: new FormControl('', []),
    kpiName: new FormControl('', []),
    kpiQueue: new FormControl('', [Validators.required]),
    kpiWhisper: new FormControl('', []),
    department: new FormControl('', [])
  });

  ngOnInit(): void {
    //queues, languages get from lambdas
    this.telecomService.getLanguages().then((resultData:any)=>{
      console.log("get language result: ", resultData);
      this.languages = resultData.languages;
    });
    this.getQueues();
    this.getCampaigns();
    this.form.get('campaignType').valueChanges.subscribe(val => {
      if (val != "Marketing Campaign") { // for setting validations
        this.form.get('whisper').setValidators(Validators.required);
        this.form.patchValue({'experienceType':"Direct to Queue"});
        this.form.get('experienceType').setValidators([Validators.required, Validators.pattern('Direct to Queue')])
      } 
      else { // for clearing validations
        this.form.get('whisper').clearValidators();
        this.form.get('experienceType').setValidators([Validators.required])
      }
      this.form.get('whisper').updateValueAndValidity();
  });
  }

  handleButtonEvent(e: any){
    console.log(e);
    if(e.button == "create"){
      this.creatingRow = true;
      this.rowSelected = 0;
      return;
    }
    if(e.button == "edit"){
      this.form.get('name').clearValidators();
      this.form.get('phoneNumber').clearValidators();
      for(let i=0;i<this.filteredData.length;i++){
        let row = this.filteredData[i]
        let rowKey = row.id;
        let itemKey = e.item.id;
        if(rowKey == itemKey){
          this.rowSelected = i;
          console.log(i)
          break;
        }
      }
    }
    if(e.button == "confirm" || e.button == "delete"){
      if(e.button == "confirm"){
        this.editable = false;
      }
      this.filteredData[this.rowSelected]["phoneNumber"] = this.formatPhoneNumber(e.item["phoneNumber"])
      if (this.creatingRow){
        let now = new Date();
        let createdDate = this.timeService.getDateTimeString(now);
        e.item["creator"] = this.currentUser;
        e.item["created"] = createdDate;
        e.item["id"] = this.GUID();
      }
      this.updateRow(e.item, this.filteredData);
      let newData = this.filteredData[this.rowSelected];
      let params = {
        FunctionName: environment.CampaignLambdaName,
        Payload: JSON.stringify({
          operation: 'put',
          data: newData
        })
      };
      this.telecomService.callLambda(params, 'An error occurred while trying to save campaign data: ').then((response: any) => {
        if(response.statusCode == 200){
          console.log(response);
          //get data from response and syncronize local copy
          this.data = JSON.parse(response.body);
          console.log(`data updated:`);
          console.log(this.data);
          this.getCampaigns();
        }else{
          console.error(response); 
          this.snackbar.open(`Error: ${response.Error}`, "Ok", {verticalPosition: 'bottom'});
        }
      });
    }
    this.creatingRow = false;
  }

  handleKPIButtonEvent(e: any){
    console.log(e);
    if(e.button == "create"){
      this.creatingRow = true;
      this.rowSelected = 0;
      return;
    }
    if(e.button == "edit"){
      this.kpiForm.get('kpiPhoneNumber').clearValidators();
      this.kpiForm.get('kpiName').clearValidators();
      for(let i=0;i<this.kpiData.length;i++){
        let row = this.kpiData[i]
        let rowKey = row.id;
        let itemKey = e.item.id;
        if(rowKey == itemKey){
          this.rowSelected = i;
          console.log(i)
          break;
        }
      }
    }
    if(e.button == "confirm" || e.button == "delete"){
      if(e.button == "confirm"){
        this.editable = false;
      }
      this.kpiData[this.rowSelected]["phoneNumber"] = this.formatPhoneNumber(e.item["phoneNumber"])
      if (this.creatingRow){
        let now = new Date();
        let createdDate = this.timeService.getDateTimeString(now);
        e.item["creator"] = this.currentUser;
        e.item["created"] = createdDate;
        e.item["id"] = this.GUID();
      }
      this.updateRow(e.item, this.kpiData);
      let newData = this.kpiData[this.rowSelected];
      let params = {
        FunctionName: environment.CampaignLambdaName,
        Payload: JSON.stringify({
          operation: 'put',
          data: newData
        })
      };
      this.telecomService.callLambda(params, 'An error occurred while trying to save campaign data: ').then((response: any) => {
        if(response.statusCode == 200){
          console.log(response);
          //get data from response and syncronize local copy
          this.data = JSON.parse(response.body);
          console.log(`data updated:`);
          console.log(this.data);
          this.getCampaigns();
        }else{
          console.error(response); 
          this.snackbar.open(`Error: ${response.Error}`, "Ok", {verticalPosition: 'bottom'});
        }
      });
    }
    this.creatingRow = false;
  }

  filterData(){
    this.filteredData = this.data.filter((row) => {return (row.enabled && row.type == "campaign")});
    this.inactiveData = this.data.filter((row) => {return (!row.enabled && row.type == "campaign")});
    this.kpiData = this.data.filter((row) => {return (row.type == "kpi")});
    this.form.get('name').setValidators([Validators.required, this.uniqueNameValidator.onlyUniqueKeys(this.data, this.rowSelected)]);
    this.form.get('phoneNumber').setValidators([Validators.required, Validators.pattern(/^(\+?\d{1,2})?\s?\(?(\d{3})\)?[\s.-]?(\d{3})[\s.-]?(\d{4})$/), this.uniqueNameValidator.onlyUniqueNumbers(this.data, this.formatPhoneNumber)]);
    this.kpiForm.get('kpiName').setValidators([Validators.required, this.uniqueNameValidator.onlyUniqueKeys(this.data, this.rowSelected)]);
    this.kpiForm.get('kpiPhoneNumber').setValidators([Validators.required, Validators.pattern(/^(\+?\d{1,2})?\s?\(?(\d{3})\)?[\s.-]?(\d{3})[\s.-]?(\d{4})$/), this.uniqueNameValidator.onlyUniqueNumbers(this.data, this.formatPhoneNumber)]);
  }

  getQueues(){
    this.telecomService.getRows(environment.QueuesLambdaName).then((data: any) => {
      if(data.statusCode == 200){
        this.queues = data.body.queueList;
        this.kpiQueues = this.queues.filter((queue : any) => {
          if(queue.queueName.startsWith("kpi")){
            return true
          }
          return false
        });

        this.queues = this.queues.filter((queue : any) => {
          if(queue.queueName.startsWith("dtc")){
            return true
          }
          return false
        });

      }
      else{
        console.error(data.Error)
      }
    });
  }

  getCampaigns(){
    this.telecomService.getRows(environment.CampaignLambdaName).then((data: any) => {
      console.log(data)
      this.data = JSON.parse(data.body);
      this.filterData();
      this.editable = true;
      if(data.statusCode != 200){
        console.log("Error: ", data.Error)
      }
    });
  }

  updateRow(newrow, data){
    let now = new Date();
    let createdDate = this.timeService.getDateTimeString(now);
    newrow["updatedBy"] = this.currentUser;
    newrow["lastUpdated"] = createdDate;
    let row = data.findIndex((row) => row.id == newrow.id);
    data[row] = newrow;
    return newrow
  }
  
  validatePhoneNumber(phoneNumber){
    let formattedNumber = this.displayFormatPhoneNumber(phoneNumber);
    this.form.patchValue({'phoneNumber':formattedNumber});
  }
  validateKPIPhoneNumber(phoneNumber){
    let formattedNumber = this.displayFormatPhoneNumber(phoneNumber);
    this.kpiForm.patchValue({'kpiPhoneNumber':formattedNumber});
  }

  displayFormatPhoneNumber(phoneNumber){
    //regex to format string
    let formattingRegex = /^(\+?\d{1,2}\s?)?(\d{3})(\d{3})(\d{4})$/;
    let matches = formattingRegex.exec(phoneNumber);
    let formattedNumber = phoneNumber;
    if (matches && matches.length >= 4){
      if(matches[1]){
        formattedNumber = `${matches[1]} (${matches[2]}) ${matches[3]}-${matches[4]}`;
      }
      else{
        formattedNumber = `(${matches[2]}) ${matches[3]}-${matches[4]}`;
      }
    }
    return formattedNumber;
  }


  formatPhoneNumber(phoneNumber){
    let formattedNumber = phoneNumber;
    let formattingRegex = /^(\+?\d{1,2})?\s?\(?(\d{3})\)?[\s.-]?(\d{3})[\s.-]?(\d{4})$/;
    let matches = formattingRegex.exec(phoneNumber);
    if (matches && matches.length >= 4){
      if(matches[1]){
        formattedNumber = `${matches[1]}${matches[2]}${matches[3]}${matches[4]}`;
      }
      else{
        formattedNumber = `+1${matches[2]}${matches[3]}${matches[4]}`;
      }
    }
    return formattedNumber
  }

  GUID(){
    return Guid.create()['value'];
  }
}
